import keywordsJson from "./keywords.json";

// keywords.json is the single source of truth shared with the LLM
// card-generation prompt (Python loader).
export interface KeywordEntry {
  name: string;
  summary: string;
}

const RAW: { keywords: KeywordEntry[] } = keywordsJson as { keywords: KeywordEntry[] };

export const KEYWORDS: readonly KeywordEntry[] = RAW.keywords;

const BY_NAME: Record<string, KeywordEntry> = Object.fromEntries(
  KEYWORDS.map((k) => [k.name, k]),
);

/** Look up the canonical summary for a keyword (case-insensitive). */
export function keywordSummary(name: string): string | null {
  const entry = BY_NAME[name.toLowerCase()];
  return entry ? entry.summary : null;
}

/** All keyword names (lowercase). Order matches `keywords.json`. */
export const KEYWORD_NAMES: readonly string[] = KEYWORDS.map((k) => k.name);
